import React, { useEffect, useState } from "react";
import {
  Radio,
  Divider,
  Form,
  Input,
  message,
  Button,
  TimePicker,
  DatePicker,
  Select,
  Space,
  Modal,
} from "antd";
import ProfilePicture from "../../assets/profile.png";
import "./RDBProfile.scss";
import { useParams } from "react-router-dom";

function RDBProfile({ resumeResult }) {
  return (
    <div className="rdb-profile-summary-wrapper">
      <div className="profile-summary-container-center">
        <img
          className="profile-picture"
          src={ProfilePicture}
          alt="Profile Picture"
        />
      </div>
      <div className="profile-summary-title-container">
        <h5 className="profile-summary-title">
          {resumeResult?.personaldetail?.name}
        </h5>
        <div className="profile-summary-skills">
          <label>Skills : </label>
          <span>{resumeResult?.skilltags}</span>
        </div>
      </div>
      <div className="profile-summary-container">
        <div className="profile-summary-container-right">
          <div className="profile-summary-container-right-top"></div>
          <div className="profile-summary-container-right-bottom">
            {/* LOCATION & MOBILITY */}
            <div className="profile-summary-details-title">Contact Details</div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Ph Number :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.personaldetail?.mobile}
              </span>

              <label className="profile-summary-details-row-label">
                Email Id:{" "}
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.personaldetail?.email}
              </span>
            </div>
            <hr />
            {/* LOCATION & MOBILITY */}
            <div className="profile-summary-details-title">
              Location
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Current Location :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.currentlocation}
              </span>

              <label className="profile-summary-details-row-label">
                Preferred Locations :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>

              <label className="profile-summary-details-row-label">
                Relocation Reason :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>
            </div>
            <hr />
            {/* CURRENT EMPLOYMENT */}
            <div className="profile-summary-details-title">
              Current Employment
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Current Company :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.currentcompany}
              </span>

              <label className="profile-summary-details-row-label">
                Current Designation :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.designation}
              </span>

              <label className="profile-summary-details-row-label">
                Current CTC (LPA) :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.currentctc?.totalctc}
              </span>

              <label className="profile-summary-details-row-label">
                LWD (Last Working Day) :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.noticeperiod?.lwd}
              </span>

              <label className="profile-summary-details-row-label">
                Reason for Leaving :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>
            </div>
            <hr />
            {/* EXPERIENCE SUMMARY */}
            <div className="profile-summary-details-title">
              Experience Summary
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Total Exp (Yrs) :{" "}
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>

              <label className="profile-summary-details-row-label">
                Relevant Exp (Yrs):
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>
            </div>
            <hr />
            {/* COMPENSATION EXPECTATIONS */}
            <div className="profile-summary-details-title">
              Compensation Expectations
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                ECTC (LPA):
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>

              <label className="profile-summary-details-row-label">
                ECTC Options:
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>

              <label className="profile-summary-details-row-label">
                Offered CTC (Internal):
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>

              <label className="profile-summary-details-row-label">
                Expected DOJ:
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>
            </div>
            <hr />
            {/* NOTICE PERIOD & AVAILABILITY */}
            <div className="profile-summary-details-title">
              Notice Period & Availability
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Official Notice Period (Days):
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.noticeperiod?.officalnp}
              </span>

              <label className="profile-summary-details-row-label">
                Negotiable Notice Period:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.noticeperiod?.negotiableto}
              </span>

              <label className="profile-summary-details-row-label">
                Job Continuity:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.jobcontinuity}
              </span>

              <label className="profile-summary-details-row-label">
                Currently Not Working Due To:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.employmentdetails?.notworkingreason}
              </span>
            </div>
            <hr />
            {/* ACTIVE OPPORTUNITIES */}
            <div className="profile-summary-details-title">
              Other Offers
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Other Offers:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.offerdetails?.otheroffers}
              </span>
            </div>
            <hr />
            {/* EDUCATION */}
            <div className="profile-summary-details-title">Education</div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Max Degree:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.educationaldetail?.maxdegree}
              </span>

              <label className="profile-summary-details-row-label">
                Year of Passing:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.educationaldetail?.passoutyear}
              </span>

              <label className="profile-summary-details-row-label">
                Uni/College:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.educationaldetail?.college}
              </span>

              <label className="profile-summary-details-row-label">
                Stream:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.educationaldetail?.stream}
              </span>

              <label className="profile-summary-details-row-label">
                Percentage/CGPA:
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>
            </div>
            <hr />
            {/* PERSONAL & IDENTIFICATION */}
            <div className="profile-summary-details-title">
              Personal & Identification
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                Date of Birth:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.personaldetail?.dob}
              </span>

              <label className="profile-summary-details-row-label">
                Gender:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.personaldetail?.gender}
              </span>

              <label className="profile-summary-details-row-label">
                Aadhar Number:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.personaldetail?.aadharid}
              </span>

              <label className="profile-summary-details-row-label">
                UAN Number:
              </label>
              <span className="profile-summary-details-row-span">
                {resumeResult?.personaldetail?.uan}
              </span>
            </div>
            <hr />
            {/* INTERNAL ASSESSMENT */}
            <div className="profile-summary-details-title">
              Internal Assessment
            </div>
            <div className="profile-summary-details">
              <label className="profile-summary-details-row-label">
                CTC Remarks:
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>

              <label className="profile-summary-details-row-label">
                Soft Skills (Internal):
              </label>
              <span className="profile-summary-details-row-span">
                NOT FOUND
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* </div> */}
    </div>
  );
}

export default RDBProfile;
